module.exports = __webpack_public_path__ + "static/media/Regulering_PBE_Tegnbeskrivelse.e7420757.png";